import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroupDirective, FormGroup, FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subject, Subscription } from 'rxjs';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';
import { DomicilioDTO } from '../../models/domicilio-dto';
import { ContattoDTO } from '../../models/contatto-dto';
import { SelectionModel } from '@angular/cdk/collections';
import { ComponentReducer } from '../../utils/component-reducer';
import { map, shareReplay, startWith, tap } from 'rxjs/operators';
import { MessageService } from '../../services/message.service';
import { Domicilio } from '../../models/portale/domicilio';
import { Recapito } from '../../models/portale/recapito';

@Component({
	selector: 'lib-dati-domicilio',
	templateUrl: './dati-domicilio.component.html',
	styleUrls: ['./dati-domicilio.component.css']
})
export class DatiDomicilioComponent implements OnInit, OnDestroy {

	form: FormGroup;

	@Input() domicili: Array<Domicilio>;

	@Input() recapiti$: Observable<Array<Recapito>>;

	@Input()
	domicilio: DomicilioDTO;

	@Output()
	done: EventEmitter<ComponentOutputStatus<DomicilioDTO>> = new EventEmitter<ComponentOutputStatus<DomicilioDTO>>();

	subscription: Subscription;

	displayedColumns: string[] = ['tipo', 'presso', 'indirizzo', 'preferito', 'seleziona'];

	dataSource: MatTableDataSource<any>;

	selection: SelectionModel<Domicilio>;

	@ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;

	checkDomicilio$: Observable<Boolean>;

	changesRecapito$ = new Subject<
		ComponentOutputStatus<(value: DomicilioDTO) => void>
	>();

	validazioneDomicilio: boolean = false;

	tipoToltip = "tipo";
	pressoToltip = "presso";
	indirizzoToltip = "indirizzo";
	selezionaToltip = "seleziona";
	preferitoToltip = "preferito";

	constructor(private msg: MessageService) { }

	ngOnInit(): void {

		// console.log('[domicilio]', this.domicilio);
		console.log('[domicili]', this.domicili);

		this.form = new FormGroup({});
		let valid = true;

		if (!this.domicilio) {
			this.initDomicilio();
			valid = false;
		}

		this.dataSource = new MatTableDataSource(this.domicili);
		this.selection = new SelectionModel<Domicilio>(false, []);

		this.initialSelection();

		const domicilio = new FormControl({ value: this.domicilio.hasSelezionatoDomicilio, disabled: false });
		this.form.addControl('domicilio', domicilio);

		const selected = new FormControl({ value: '', disabled: false });
		this.form.addControl('selected', selected);

		this.checkDomicilio$ = domicilio.valueChanges.pipe(shareReplay())
			.pipe(
				tap(checkDomicilio => {
					if (checkDomicilio == false) {
						this.selection.clear();
					}
				}),
				startWith(this.domicilio.idDomicilioSelezionato != null)
			);

		const changesCheckDomicilio$ = this.checkDomicilio$.pipe(
			map(checkDomicilio =>
				ComponentOutputStatus.of(true, (domicilio: DomicilioDTO) => {
					domicilio.hasSelezionatoDomicilio = checkDomicilio;
					if (checkDomicilio == false) {
						domicilio.contatto.email = null;
						domicilio.contatto.pec = null;
						domicilio.contatto.telefono = null;
						this.form.get('selected').setValue('');
					}
				}
				))
		);

		const changesDomicilio$ = this.selection.changed.pipe(
			tap((value) => {
				// console.log("changesDomicilio$", value);
				this.validazioneDomicilio = value.added.length > 0 ? false : true;
			}),
			map(change =>
				ComponentOutputStatus.of(true, domicilio => {
					domicilio.idDomicilioSelezionato = change.added.length > 0 ? change.added[0].id : null;
				}
				))
		);

		this.subscription = ComponentReducer.reducer3(
			changesCheckDomicilio$,
			changesDomicilio$,
			this.changesRecapito$,
			domicilio => {
				return domicilio.hasSelezionatoDomicilio ?
					domicilio.idDomicilioSelezionato != null : true
			},
			ComponentOutputStatus.of(true, this.domicilio)
		)
			.subscribe(domicilio => {
				// console.log('[DatiDomicilioComponent] status', status);
				this.done.emit(domicilio)
			});

		this.form.setValidators(form => {

			if (form.get('domicilio').value && !form.get('selected').value) {
				this.validazioneDomicilio = true;
				return { requiredDomicilio: true }
			} else {
				return null
			}

			//TODO
			// return form.get('domicilio').value &&
			// 	!form.get('selected').value ?
			// 	// this.selection.isEmpty() ?
			// 	// this.selection.selected.length === 1 ?
			// 	{ requiredDomicilio: true } : null;
		});
	}

	initialSelection() {
		if (this.domicilio.idDomicilioSelezionato) {
			setTimeout(() => {
				this.dataSource.data
					.forEach(row => {
						if (row.id == this.domicilio.idDomicilioSelezionato) {
							this.selection.select(row);
							this.validazioneDomicilio = false;
						}
					});
			}, 0);
		}
	}

	initDomicilio() {
		this.domicilio = new DomicilioDTO();
		this.domicilio.contatto = new ContattoDTO();
	}

	public recapitiReady(recapitiStatus: ComponentOutputStatus<ContattoDTO>) {
		// console.log('[recapitiReady]', recapitiStatus);
		this.changesRecapito$.next(
			recapitiStatus.mapValue((contatto) => (dich: DomicilioDTO) =>
				(dich.contatto = contatto)
			)
		);
	}

	ngOnDestroy(): void {
		if (this.subscription != null) {
			this.subscription.unsubscribe()
		}
	}
}
